<template>
  <div v-loading="load">
    <h3 class="topTitle">TOTAL CONDUCTORES
      <el-tag
        :type="tagType"
        size="mini">{{totalDrivers}}</el-tag></h3>
    <div class="delayedTrucksTable roundedBorder">
      <el-table :data="drivers" height="100%" width="100%">
        <el-table-column label="#" type="index" align="center">
        </el-table-column>
        <el-table-column
          label="NOMBRES"
          min-width="120"
          align="center">
          <template slot-scope="scope">
            {{scope.row.first_name}}
          </template>
        </el-table-column>
        <el-table-column
          label="APELLIDOS"
          min-width="120"
          align="center">
          <template slot-scope="scope">
            {{scope.row.last_name}}
          </template>
        </el-table-column>
        <el-table-column
          label="RUT"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            {{scope.row.rut}}
          </template>
        </el-table-column>
        <el-table-column label="ACTIVAR"
                         align="center"
                         min-width="75"
                         prop="active" >
          <template      slot-scope="scope"
                         align="center">
              <el-switch v-model="scope.row.active"
                         @change="changeActivate(scope.row)">
              </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { apiRequest } from '../../backend/vue-axios/axios';

export default {
  name: 'TracingEnterpriseDrivers',
  props: {
    enterprise: {
      type: Number,
    },
  },
  data() {
    return {
      load: false,
      tagType: 'info',
      totalDrivers: 0,
      drivers: [],
    };
  },
  methods: {
    changeActivate(row) {
      const text = ((row.active) ? 'habilitar' : 'deshabilitar');
      this.$confirm(`¿Seguro que desea ${text} al conductor ${row.first_name} ${row.last_name} ?.`, 'Cuidado', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        apiRequest({
          module: 'tracing',
          service: 'toggle_driver',
          params: {
            rut: row.rut,
            toggle: row.active,
          },
        }).then((res) => {
          this.$notify({
            type: 'success',
            title: 'OK',
            message: res.data.message, // TODO No envia mensaje al activar la ruta.
          });
        }).catch((error) => {
          const selectedDriver = this.drivers.filter(driver => driver.id === row.id);
          selectedDriver[0].active = !row.active;
          if (error.response) {
            this.$notify({
              type: 'error',
              title: 'Error',
              message: error.response.data.message,
            });
          }
        });
      }).catch(() => {
        const selectedDriver = this.drivers.filter(driver => driver.id === row.id);
        selectedDriver[0].active = !row.active;
      });
    },
    setDrivers() {
      this.load = true;
      apiRequest({
        module: 'tracing',
        service: 'drivers',
        params: {
          limit: 1000,
        },
      }).then((result) => {
        this.drivers.pop();
        this.drivers = result.data;
        this.totalDrivers = this.drivers.length;
        this.load = false;
      }).catch(() => {
        this.load = false;
        this.$notify.error({
          title: 'Error',
          message: 'Error al obtener información',
        });
      });
    },
  },
  created() {
    this.setDrivers();
  },
  watch: {
    enterprise() {
      this.setDrivers();
    },
  },
};
</script>

<style scoped>
  .topTitle {
    font-size: 12px;
    color: #707070;
    text-align: left;
    margin: 0 5px 5px 0;
  }
  .roundedBorder {
    box-sizing: border-box;
    border-radius: 3px;
    background: white;
    height: 70vh;
  }
</style>
